// extracted by css-extract-rspack-plugin
var _1 = "_YbwB50b66QaMy2l";
var _2 = "wKYEP31LjAYlDRq9";
var _3 = "GI1g0TyX8Rovn70n";
var _4 = "GI1g0TyX8Rovn70n";
export { _1 as "button", _2 as "identifier", _3 as "matchday-modal", _4 as "matchdayModal" }
